import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { FileUploadModule } from 'primeng/fileupload';
import { IconFieldModule } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-upload-sample-firmware-file',
    imports: [
        CommonModule,
        FormsModule,
        FileUploadModule,
        ButtonModule,
        TooltipModule,
        ProgressSpinnerModule,
        InputTextModule,
        IconFieldModule,
        InputIconModule,
        IftaLabelModule
    ],
    templateUrl: './upload-sample-firmware-file.component.html',
    styleUrl: './upload-sample-firmware-file.component.scss'
})
export class UploadSampleFirmwareFileComponent {
  @Input() public fileName: string | null = null;
  @Input() public resetTrigger = false;
  @Output() public fileSelected = new EventEmitter<File | null>();

  public uploading = false;

  /**
   * On changes to the component.
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['resetTrigger']?.currentValue === true) {
      this.fileName = null;
      this.uploading = false;
    }
  }

  /**
   * Selectes the file to be uploaded.
   */
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) return;

    // Basic validation
    const validExtension = /\.bin$/i;
    if (!validExtension.test(file.name)) {
      alert('Only .bin files are allowed.');
      input.value = '';
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      alert('File size must be under 2MB.');
      input.value = '';
      return;
    }

    if (file.name.includes('..') || /[<>:"/\\|?*]/.test(file.name)) {
      alert('Invalid file name.');
      input.value = '';
      return;
    }

    this.uploading = true;
    this.fileName = file.name;

    // Loading animation upon selection of a file.
    setTimeout(() => {
      this.uploading = false;
      this.fileSelected.emit(file);
    }, 1000);
  }

  /**
   * Upon selection of a file.
   */
  triggerFileSelect(input: HTMLInputElement) {
    input.value = '';
    input.click();
  }

  /**
   * Upon removal of a selected file.
   */
  removeFile(input?: HTMLInputElement) {
    this.fileName = null;
    if (input) {
      input.value = '';
    }
    this.fileSelected.emit(null);
  }
}
